import React from "react";
import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";
import {GetUserToken} from "../../../api/token";
import {PostToPbx} from "../../../api/http-post";
import {fetchDataEntity} from "../../../api/entity-data";
import {LoadDataAnyEndpoint, SortData, UpcaseFirst} from "../../../api/fn";
import {Select, Row, Col, Form} from "antd";
import TableDataView from "../../../components/Common/tables/TableDataView";
import NewEntityDrawer from "../../../components/Common/workboard/NewEntityDrawer";

const {Option} = Select;

class WorkboardViewEntitiesPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Modules: [],
            Projects: [],
            Fields: [],
            Entities: [],
            isLoading: false,
            component: "list",
            newEntry: {},
            selectedCompany: "",
            selectedProject: "",
            selectedEntity:"",
            Informations:[],
            selectedRecord:null,
            showDrawer:false,
        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this);
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("Fields", "", "", this, undefined, "common/entity/Fields/list");
        await fetchDataEntity("Entities", "", "", this, undefined, "common/entity/Entities/list");
        await fetchDataEntity("Informations", "", "", this, undefined, "common/entity/Informations/list");
        await this.loadUsers();
    }
    loadUsers = async () => {
        let userInfo = GetUserToken();
        let hub = {};
        // hub.Org = userInfo.Org;
        let endpoint = "/user/list";
        await LoadDataAnyEndpoint(hub, endpoint, "Users", this, (data) => {
            console.log("loadUsers > ", data)
        });

    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("SettingSetupSitePage loadInitialData response > ", post, " > ", data);
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }

    handleChange = async (e, key) => {
        const value = e.value;
        this.setState({
            [key]: value,
        })
    }
    onAddRecord=(record)=>{

        let org = this.state.selectedCompany;
        let project = this.state.selectedProject;
        let entity = this.state.selectedEntity;

        if (org=== "") {
            return alert("Sorry please select company before adding record!")
        }
        if (project=== "") {
            return alert("Sorry please select project before adding record!")
        }
        if (entity=== "") {
            return alert("Sorry please select entity before adding record!")
        }

        this.setState({
            selectedRecord:record,
            showDrawer:true,
        });
        console.log("onAddRecord > ",record);
    }
    onDeleteView=(record)=>{
        console.log("onDeleteView > ",record);

    }

    renderCompaniesComboBox = () => {
        let user = GetUserToken();
        let ls = [];
        for (let i in this.state.Companies) {
            const row = this.state.Companies[i];
            if (user.Role === "super") {
                ls.push({
                    key: row.CustomerNumber,
                    val: row.Name,
                })
            } else {
                if (row.CustomerNumber === user.Org) {
                    ls.push({
                        key: row.CustomerNumber,
                        val: row.Name,
                    })
                }
            }


        }
        return (
            <Select
                name={"selectedCompany"}
                defaultValue=""
                onChange={(e, ee) => this.handleChange(ee, "selectedCompany")}
            >
                {ls.map((record, index) => {
                    return (
                        <Option value={record.key}>{record.val}</Option>
                    )
                })}
            </Select>
        )
    }
    renderProjectComboBox = () => {
        let ls = [];
        let {org} = this.getInfo();
        console.log("renderProjectComboBox > ",org);
        for (let i in this.state.Projects) {
            const row = this.state.Projects[i];

            if (row.org === org) {
                ls.push({
                    key: row.name,
                    val: row.name,
                })
            }
        }
        return (
            <Select
                name={"selectedProject"}
                defaultValue=""
                onChange={(e, ee) => this.handleChange(ee, "selectedProject")}
            >
                {ls.map((record, index) => {
                    return (
                        <Option value={record.key}>{record.val}</Option>
                    )
                })}
            </Select>
        )
    }
    renderEntityComboBox = () => {
        let ls = [];
        let {org} = this.getInfo();
        let project = this.state.selectedProject;
        for (let i in this.state.Entities) {
            const row = this.state.Entities[i];

            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }

            ls.push({
                key: row.name,
                val: row.name,
            })

        }
        return (
            <Select
                name={"selectedEntity"}
                defaultValue=""
                onChange={(e, ee) => this.handleChange(ee, "selectedEntity")}
            >
                {ls.map((record, index) => {
                    return (
                        <Option value={record.key}>{record.val}</Option>
                    )
                })}
            </Select>
        )
    }

    getAttributes=()=>{
        let state = this.state;
        let ls=[];
        let {org}= this.getInfo();
        let project = this.state.selectedProject;
        let entity = this.state.selectedEntity;
        for(let  i in state.Fields){
            let row = state.Fields[i];
            if(row.org!==org){continue}
            if(row.module!==project){continue}
            if(row.category!=="entity"){continue}
            if(row.ref!==entity){continue}
            ls.push(row);
        }
        ls=SortData("position",ls);
        return ls;
    }
    getInfo=()=>{
        let user = GetUserToken();
        let org = this.state.selectedCompany;
        let project = this.state.selectedProject;
        let role = user.Role;
        console.log("getInfo > ",user)
        if(user.Role!=="super"){
            org  = user.Org;
        }
        return{org,project,role}
    }
    renderList=()=>{

        let attributes = this.getAttributes();

        let columns = [
            /*{id: 'mobile', label: '', minWidth: 170, dataType: "string"},
            {id: 'link', label: 'Profile Pic.', minWidth: 170, dataType: "string"},*/
        ];
        for(let i in attributes){
            let row=attributes[i];
            columns.push({
                id: row.fieldname,
                label: row.fieldname,
                minWidth: 170,
                dataType: row.datatype
            })
        }
        let ls=[];
        let {org,project} = this.getInfo();
        let entity = this.state.selectedEntity;

        for(let i in this.state.Informations){
            let row=this.state.Informations[i];
            if (row.org !== org) {
                continue
            }
            if (row.project !== project) {
                continue
            }
            if (row.action !== "entity") {
                continue
            }
            if(row.category!==entity){
                continue
            }

            let dataIn = row.data;
            dataIn.record = row;
            ls.push(dataIn);
        }


        let data = {columns: columns, data: ls}
        return (
            <TableDataView
                {...data}
                tableTitle={" Records  (" + data.data.length + ") "}
                otherFunctions={[]}
                allowedAdd={false}
                allowDelete={false}
                options={{
                    pageSize:20,
                }}
            />
        )
    }

    render() {
        let {org,project,role}=this.getInfo();
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>View Entities</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <Row gutter={16} style={{marginTop: 20}}>
                            {role==="super"?
                            <Col span={8}>
                                <Form.Item
                                    label={"Select Company"}
                                >
                                    {this.renderCompaniesComboBox()}
                                </Form.Item>
                            </Col>:null}
                            <Col span={8}>
                                <Form.Item
                                    label={"Select Project"}
                                >
                                    {this.renderProjectComboBox()}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label={"Select Entity"}
                                >
                                    {this.renderEntityComboBox()}
                                </Form.Item>
                            </Col>
                        </Row>
                        {this.renderList()}

                        <NewEntityDrawer _this={this}/>
                    </div>
                </div>
            </Page>
        )
    }

}


export default Connector(WorkboardViewEntitiesPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
